<script>
import SettingsSidebar from "@/components/rubrics/newRubric/settings_sidebar.vue";
import Settings from "@/components/rubrics/newRubric/settings.vue";
import RubricForm from "@/components/rubrics/rubric_form.vue";
import RubricFullscreenModal from "@/components/rubrics/components/rubric_fullscreen_modal.vue";
import RubricFormActions from "@/components/rubrics/newRubric/components/rubric_form_actions.vue";
import RubricSettingsTab from "@/components/rubrics/components/rubric_settings_tab.vue";
import RubricPreviewTab from "@/components/rubrics/components/rubric_preview_tab.vue";
import rubricFormStateMixin from "@/mixins/rubricFormStateMixin";

export default {
  name: "RubricFromScratch",
  components: {
    RubricForm,
    Settings,
    SettingsSidebar,
    RubricFullscreenModal,
    RubricFormActions,
    RubricSettingsTab,
    RubricPreviewTab,
  },
  mixins: [rubricFormStateMixin],
  inject: ["clearRubricSettings"],
  emits: ["createRubric", "close"],
  data() {
    return {
      step: 0,
      settings: {
        grade: true,
        intensity: true,
        language: true,
      },
    };
  },
  beforeMount() {
    this.clearRubricSettings();
  },
  methods: {
    handleSubmit() {
      if (this.$refs.rubricForm) {
        this.$refs.rubricForm.handleSubmit();
      }
    },
    handleCreateRubric(rubricData) {
      this.$emit("createRubric", rubricData);
    },
  },
};
</script>

<template>
  <div class="rubric-from-scratch-wrapper">
    <!-- Fullscreen Rubric Form -->
    <RubricFullscreenModal
      v-show="step === 1"
      ref="fullscreenModal"
      mode="create"
      :show-tabs="true"
      @cancel="$emit('close')"
      @save="handleSubmit"
      @back="step = 0"
    >
      <!-- Edit Tab Content -->
      <template #default>
        <div>
          <rubric-form
            v-if="step === 1"
            :key="`scratch-form-${step}`"
            ref="rubricForm"
            :hide-actions="true"
            @rubricSubmitted="handleCreateRubric"
            @formDataUpdate="handleFormDataUpdate"
            @switchToFirstTab="$refs.fullscreenModal.activeTab = 0"
            @close="$emit('close')"
          />
        </div>
      </template>

      <!-- Preview Tab Content -->
      <template #preview>
        <RubricPreviewTab
          :key="`preview-${rubricFormData.name}-${
            rubricFormData.criterias?.length || 0
          }`"
          :rubric="rubricFormData"
        />
      </template>

      <!-- Settings Tab Content -->
      <template #settings>
        <RubricSettingsTab grade intensity language />
      </template>
    </RubricFullscreenModal>

    <!-- Normal Modal Content -->
    <div v-show="step === 0">
      <eg-b-row class="full-width rubric-form-body" no-gutters>
        <SettingsSidebar v-bind="settings" />
        <eg-b-col cols="12" class="rubric-form-content">
          <Settings v-bind="settings" />
        </eg-b-col>
      </eg-b-row>
      <RubricFormActions
        :on-cancel="() => $emit('close')"
        :on-submit="() => (step = 1)"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.rubric-from-scratch-wrapper {
  position: relative;
  width: 100%;
}
</style>
